export const ParseFile = 0;
export const MapScript = 1;
export const LocationsResolve = 2;
export const Vaidation = 3;
export const ApiOperations = 4;
export const CostCalculation = 5;
export const Created = 6;
export const ExternalProviders = 7;
export const DuplicationDetector = 8;